import React, { FunctionComponent, ReactNode } from 'react';
import { Button, Icon, Modal } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../..';
import { ILabel } from '../../../../models/common/label.model';
import { IPDPMedia, getPrimaryImageUrl } from '../../../../models/pdp/pdp-media.model';
import styles from './confirmation-modal-component.module.scss';

type ConfirmationModalProps = {
  labels?: ILabel[] | null;
  confirmationModalTitle: string;
  contentsTitle?: string;
  title?: string;
  details?: ReactNode;
  mediaArea?: IPDPMedia | null;
  imageUrl?: string;
  viewButtonHref?: string;
  viewButtonText: string;
  backButtonText: string;
  viewButtonCallback?: () => void;
  closeCallback: () => void;
};

export const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = (props: ConfirmationModalProps) => {
  return (
    <Modal
      className={styles['confirmation-modal']}
      closeCallback={props.closeCallback}
      headerElt={
        <div className={styles.header}>
          <Icon name='done' />
          <p className={styles.title}>{props.confirmationModalTitle}</p>
        </div>
      }>
      <div className={styles.content}>
        <p className={`snippet ${styles['content-title']}`}>{props.contentsTitle}</p>

        <div className={styles.summary}>
          {getThumbnail()}
          <div className={styles.details}>
            <p className='snippet'>{props.title}</p>
            {props.details}
          </div>
        </div>

        <div className={styles.footer}>
          <Button
            text={props.viewButtonText}
            buttonType='primary'
            href={props.viewButtonHref}
            isExternalLink={!!props.viewButtonHref}
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              if (props.viewButtonCallback) {
                e.preventDefault();
                props.viewButtonCallback();
              }
            }}></Button>
          <Button text={getLabel(props.labels, props.backButtonText)} buttonType='tertiary' onClick={props.closeCallback}></Button>
        </div>
      </div>
    </Modal>
  );

  function getThumbnail() {
    if (props.mediaArea) {
      let mediaItem = getPrimaryImageUrl(props.mediaArea, undefined, 'medium');
      if (mediaItem)
        return (
          <div className={styles.thumbnail}>
            <img id={`added-thumbnail-${mediaItem.id}`} src={mediaItem.url} alt={`thumbnail-${mediaItem.name}`} />
          </div>
        );
    }
    if (props.imageUrl) {
      return (
        <div className={styles.thumbnail}>
          <img id={`added-thumbnail`} src={props.imageUrl} />
        </div>
      );
    }
  }
};
